import { Component, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { Util } from "src/app/controller/Util";

const FIELD_VALUE_ACESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputCepComponent),
    multi: true,
};

@Component({
    selector: "app-input-cep",
    templateUrl: "./input-cep.component.html",
    styleUrl: "./input-cep.component.scss",
    standalone: false,
    providers: [FIELD_VALUE_ACESSOR],
})
export class InputCepComponent implements ControlValueAccessor {
    onChange: any = () => {};
    onTouched: any = () => {};

    @Input() label: string = "";
    @Input() placeholder = "";
    @Input() id: string = Util.randomId();
    @Input() isReadOnly = false;
    @Input() row = false;
    @Input() validacao: AbortController | FormControl | any = new FormControl;
    @Input() tentativa = false;
    @Input() lowercase = false;
    @Input() maxLength = 1000;

    @Output() onBlur = new EventEmitter<any>();
    @Output() onKeypress = new EventEmitter<any>();

    private innerValue: any;
    isDisabledByForm = false;

    constructor() { }

    get value() {
        return this.innerValue;
    }

    set value(v: any) {
        if(this.lowercase && v !== null && v !== undefined) v = v.toString().toLowerCase();
        if(v !== this.innerValue) {
            this.innerValue = v;
            this.onChange(v)
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabledByForm = isDisabled;
    }

    writeValue(v: any): void {
        this.value = v;
    }

    keyPress(event: KeyboardEvent) {
        if(this.value) this.value = this.value.toString();
        this.onKeypress.emit(event)
    }
}